import { memo } from 'react';
import PropTypes from 'prop-types';
import { filter } from 'ramda';
import ReturnTicket from './ReturnTicket';
import { isPassengerLuggageTicket } from '../../../../../helpers/passenger-helper';
const ReturnSegment = ({
  carrierName,
  segmentCityFrom,
  segmentCityTo,
  tickets,
  onTicketChange,
  selectedTickets
}) => {
  const passengerTickets = filter(ticket => !ticket.isLuggage, tickets);
  const renderLuggageTickets = passenger => {
    const luggageTickets = filter(isPassengerLuggageTicket(passenger), tickets);
    return luggageTickets.map(({
      id,
      ...ticket
    }, index) => /*#__PURE__*/React.createElement(ReturnTicket, {
      key: id,
      id: id,
      index: index,
      isMulti: luggageTickets.length > 1,
      ...ticket,
      onTicketChange: onTicketChange,
      isChecked: selectedTickets.includes(id)
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "order-return__segment"
  }, /*#__PURE__*/React.createElement("div", {
    className: "order-return__segment-description flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "order-return__segment-direction"
  }, `${segmentCityFrom} — ${segmentCityTo}`), /*#__PURE__*/React.createElement("div", {
    className: "order-return__segment-carrier"
  }, carrierName)), /*#__PURE__*/React.createElement("div", {
    className: "order-return__passangers"
  }, passengerTickets.map(({
    id,
    passenger,
    ...ticket
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReturnTicket, {
    key: id,
    id: id,
    passenger: passenger,
    ...ticket,
    onTicketChange: onTicketChange,
    isChecked: selectedTickets.includes(id)
  }), renderLuggageTickets(passenger)))));
};
ReturnSegment.propTypes = {
  carrierName: PropTypes.string,
  segmentCityFrom: PropTypes.string.isRequired,
  segmentCityTo: PropTypes.string.isRequired,
  tickets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    passenger: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      secondName: PropTypes.string
    }),
    seatNumber: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
  })),
  onTicketChange: PropTypes.func,
  selectedTickets: PropTypes.arrayOf(PropTypes.string),
  reasons: PropTypes.arrayOf(PropTypes.shape({
    reasonId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }))
};
export default /*#__PURE__*/memo(ReturnSegment);